const ACI_FAST_IDS = [67633485611256, 67633485644024]; // Standard, Fox
let aciBusy = false;
let aciCheckoutBusy = false;

function aciPost(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}

function aciRefresh() {
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'additional-cart-info' });
  } else {
    location.reload();
  }
}

async function updateCartAttributes() {
  const attributes = {};
  document.querySelectorAll('[data-cart-attr]').forEach(el => {
    attributes[el.dataset.cartAttr] =
      el.type === 'checkbox' ? (el.checked ? 'Yes' : 'No') : el.value;
  });
  await aciPost('/cart/update.js', { attributes });
}

async function toggleFastHandling(input) {
  if (aciBusy) { input.checked = !input.checked; return; }
  aciBusy = true;

  const checked = input.checked;
  const variantId = Number(input.dataset.variantId);

  try {
    const cart = await (await fetch('/cart.js')).json();
    const existing = cart.items.filter(i => ACI_FAST_IDS.includes(i.variant_id));

    if (checked && existing.length === 0) {
      const res = await aciPost('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      if (!res.ok) { input.checked = false; return; }
    } else if (!checked) {
      for (const item of existing) {
        await aciPost('/cart/change.js', { id: item.key, quantity: 0 });
      }
    }

    await aciPost('/cart/update.js', { attributes: { 'Fast Handling': checked ? 'Yes' : 'No' } });
    aciRefresh();
  } finally {
    aciBusy = false;
  }
}

// Defaults + sync (Proof default, orphan line, attribute sync, Fox variant fix)
async function applyAciDefaults() {
  if (aciBusy) return;
  aciBusy = true;
  try {
    const cart = await (await fetch('/cart.js')).json();
    if (cart.item_count === 0) return;

    const attrs = cart.attributes || {};
    const fastLines = cart.items.filter(i => ACI_FAST_IDS.includes(i.variant_id));
    const hasFast = fastLines.length > 0;
    const onlyFast = hasFast && fastLines.length === cart.items.length;
    let changed = false;

    if (onlyFast) {
      // baaki products hat gaye, akeli Fast Handling line nahi rakhni
      for (const l of fastLines) await aciPost('/cart/change.js', { id: l.key, quantity: 0 });
      await aciPost('/cart/update.js', { attributes: { 'Fast Handling': 'No' } });
      changed = true;
    } else {
      const updates = {};

      if (!attrs['Proof required']) updates['Proof required'] = 'Yes';

      const want = hasFast ? 'Yes' : 'No';
      if (attrs['Fast Handling'] !== want && (hasFast || attrs['Fast Handling'])) {
        updates['Fast Handling'] = want;
      }

      // Fox / non-Fox variant mismatch fix
      const box = document.querySelector('[data-fast-handling]');
      if (hasFast && box) {
        const desired = Number(box.dataset.variantId);
        const wrong = fastLines.filter(l => l.variant_id !== desired);
        if (wrong.length) {
          const hasDesired = fastLines.some(l => l.variant_id === desired);
          for (const l of wrong) await aciPost('/cart/change.js', { id: l.key, quantity: 0 });
          if (!hasDesired) await aciPost('/cart/add.js', { items: [{ id: desired, quantity: 1 }] });
          changed = true;
        }
      }

      if (Object.keys(updates).length) {
        await aciPost('/cart/update.js', { attributes: updates });
        changed = true;
      }
    }

    if (changed) aciRefresh();
  } finally {
    aciBusy = false;
  }
}

function handleAciChange(e) {
  const t = e.target;
  if (!t || !t.matches) return;
  if (t.matches('[data-fast-handling]')) {
    toggleFastHandling(t);
  } else if (t.matches('[data-cart-attr]')) {
    updateCartAttributes();
  }
}

window.addEventListener('change', handleAciChange, true);

// Checkout click: pehle saare fields save, phir checkout
window.addEventListener('click', async e => {
  const btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
  if (!btn || !document.querySelector('[data-cart-attr]')) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  if (aciCheckoutBusy) return;
  aciCheckoutBusy = true;

  try { await updateCartAttributes(); } catch (_) {}

  aciCheckoutBusy = false;
  if (btn.form && btn.form.requestSubmit) {
    btn.form.requestSubmit(btn);
  } else {
    window.location.href = '/checkout';
  }
}, true);

// Discount code (sirf cart page par box hai)
window.addEventListener('click', e => {
  const btn = e.target.closest && e.target.closest('[data-aci-discount-apply]');
  if (!btn) return;
  const code = btn.closest('.aci-discount').querySelector('input').value.trim();
  if (!code) return;
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname);
}, true);

document.addEventListener('DOMContentLoaded', applyAciDefaults);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
    if (e && e.source === 'additional-cart-info') return;
    applyAciDefaults();
  });
}